import { DEFAULT_FONT_ID, DEFAULT_FONT_WEIGHT, getFace } from '@/catalogs/fonts';
import { DEFAULT_PALETTE_ID, getPalette, type Palette } from '@/catalogs/palettes';
import { DEFAULT_TEMPLATE_ID, getTemplate } from '@/catalogs/templates';
import { MIN_QUIET_ZONE, type Project } from './types';

export const DEFAULT_OUTPUT_WIDTH = 1024;

/** Предустановки размера для квадратного QR. */
export const SIZE_PRESETS = [256, 512, 1024, 2048] as const;

export function createDefaultProject(): Project {
  const template = getTemplate(DEFAULT_TEMPLATE_ID);
  const palette = getPalette(DEFAULT_PALETTE_ID);
  const face = getFace(DEFAULT_FONT_ID, DEFAULT_FONT_WEIGHT);
  return {
    schemaVersion: 1,
    payload: { kind: 'url', value: '' },
    qr: {
      errorCorrection: 'M',
      quietZoneModules: MIN_QUIET_ZONE,
      foreground: palette.qrForeground,
      background: palette.qrBackground,
    },
    template: { id: template.id, version: template.version },
    paletteId: palette.id,
    title: '',
    caption: {
      text: '',
      fontId: DEFAULT_FONT_ID,
      fontRevision: face.revision,
      weight: face.weight,
      size: Math.round(DEFAULT_OUTPUT_WIDTH * 0.045),
      align: 'center',
    },
    note: '',
    output: {
      widthPx: DEFAULT_OUTPUT_WIDTH,
      format: 'png',
      includeDecoration: false,
      jpegQuality: 0.95,
      transparentBackground: false,
    },
  };
}

/**
 * Применяет палитру к проекту. Цвета QR берутся из ролей палитры, а не
 * из общего фона: поле под кодом должно оставаться белым.
 */
export function applyPalette(project: Project, palette: Palette): Project {
  return {
    ...project,
    paletteId: palette.id,
    qr: {
      ...project.qr,
      foreground: palette.qrForeground,
      background: palette.qrBackground,
    },
  };
}
